import { IColumn, Stack, Selection, SelectionMode, useTheme, ICheckboxStyles, IDetailsColumnStyles, IDetailsColumnProps, IRenderFunction, Checkbox, CheckBase, IDetailsHeaderStyles, IDetailsHeaderProps, DetailsHeader, IDetailsRowProps, DetailsRow, ProgressIndicator, DetailsList, DetailsListLayoutMode } from '@fluentui/react';
import * as React from 'react';
import { ISchedulesAttendeeList } from '../../../../../Models/Event/ISchedulesAttendeeList';
import { IUpdateAttendeeOnLesson } from '../../../../../Models/Event/IUpdateAttendeeOnLesson';
import { EmailAddressExportPanel } from '../../../Users/EmailAddressExportPanel/EmailAddressExportPanel';

interface IAttendeeListViewProps {
    items: ISchedulesAttendeeList[];
    eventId: number;
    updateAttendee: (attendee: IUpdateAttendeeOnLesson) => void;
    selectItem?: (item: ISchedulesAttendeeList) => void;
    isLoading: boolean;
    selectAttended: (item: ISchedulesAttendeeList, checked: boolean) => void;
    selectAttendedAll: (checked: boolean) => void;
}


export const AttendeeListView: React.FunctionComponent<IAttendeeListViewProps> = (props) => {

    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [selected, setSelected] = React.useState<ISchedulesAttendeeList[]>([]);

    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as ISchedulesAttendeeList[];
            setSelected(selected);
        },
        selectionMode: SelectionMode.multiple
    }));

    const theme = useTheme();

    const checkBoxStyle: Partial<ICheckboxStyles> = {
        root: {

        },
        label: {
            color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize,

        },
        text: { color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize, }
    }

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    React.useEffect(() => {
        buildColumns(props.items);
    }, [props.items])

    React.useEffect(() => {
        if (selected.length > 0) {
            props.selectItem && props.selectItem(selected[0]);
        }
    }, [selected])



    const selectAllChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
          props.selectAttendedAll && props.selectAttendedAll(checked === true);
    }

    const renderSelectAllHeader = (props: IDetailsColumnProps | undefined, defaultrender: IRenderFunction<IDetailsColumnProps> | undefined, canField: string, changeField: string) => {
        if (props) {
            const att =
                {
                    'data-canField': canField,
                    "data-changeField": changeField
                } as any;

            return <span>
                <Stack verticalFill verticalAlign="end" styles={{ root: { paddingTop: 11 } }}>
                    <Checkbox
                        inputProps={att}
                        onChange={selectAllChange} label={props.column.name} />
                </Stack>
            </span>
        }
        return null;
    }

    const buildColumns = (items: ISchedulesAttendeeList[]) => {
        const _columns: IColumn[] = [
            { key: 'firstname', isCollapsible: true, name: 'Jméno', fieldName: 'firstname', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
            { key: 'lastname', name: 'Příjmení', fieldName: 'lastname', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle },
            { key: 'attended', name: 'Přítomen', fieldName: 'attended', minWidth: 80, maxWidth: 100, isResizable: true, styles: headerStyle },
        ];
        setColumns(_columns);
    }


    const renderItemColumn = (item: ISchedulesAttendeeList, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof ISchedulesAttendeeList];
            switch (column.key) {
                case "attended":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        <Checkbox checked={item.attended} onChange={(e, v) => props.updateAttendee({ attended: (v ? v : false), attendeeId: item.id, eventId: props.eventId, id: item.eventScheduleId })} />
                    </span>
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
    

    return (
        <Stack> 
            <EmailAddressExportPanel emails={selected.map(item => {
                return { firstname: item.firstname, lastname: item.lastname, email: item.email }
            })} />

            <DetailsList
                items={props.items}
                columns={columns}
                setKey="set"
                onRenderDetailsHeader={onRenderDetailsHeader}
                selectionMode={SelectionMode.multiple}
                layoutMode={DetailsListLayoutMode.justified}
                onRenderItemColumn={renderItemColumn}
                selection={selectionState}
                selectionPreservedOnEmptyClick={false}
                ariaLabelForSelectionColumn="Výběr žáka"
                ariaLabelForSelectAllCheckbox="Výběr žáka"
                checkButtonAriaLabel="Vyber řádek"
               
                onItemInvoked={props.selectItem} />
        </Stack>)
}
